import { demoProfile } from "./users";

type CatalogItem = {
  id: string;
  userId: string;
  name: string;
  description?: string;
  price: number;
  image?: string | null;
  inStock?: boolean;
  category?: string | null;
};

type VendorFixture = {
  id: string;
  name: string;
  category: string;
  description: string;
  avatar?: string | null;
  tags?: string[];
};

const DEFAULT_VENDOR_ID = "demo-vendor";

const vendorFixtures: VendorFixture[] = [
  {
    id: DEFAULT_VENDOR_ID,
    name: demoProfile.businessName || "Demo Vendor",
    category: "Flowers & Gifts",
    description:
      demoProfile.bio ||
      "Trusted seller accepting Bankdrop orders and transfers.",
    avatar:
      demoProfile.avatar ||
      "https://images.unsplash.com/photo-1512436991641-6745cdb1723f?auto=format&fit=crop&w=400&q=80",
    tags: ["Flowers & Gifts", "Same-day delivery"],
  },
  {
    id: "coffee-cart",
    name: "Morning Coffee Cart",
    category: "Café & Snacks",
    description: "Fresh brews, iced lattes and pastries for your team standups.",
    avatar:
      "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?auto=format&fit=crop&w=800&q=80",
    tags: ["Pickup", "Office delivery", "Loyalty"],
  },
  {
    id: "tech-market",
    name: "Tech Market",
    category: "Devices & Accessories",
    description: "Verified gadgets with pay-on-delivery in select areas.",
    avatar:
      "https://images.unsplash.com/photo-1498049794561-7780e7231661?auto=format&fit=crop&w=800&q=80",
    tags: ["Warranty", "Pay on delivery"],
  },
  {
    id: "lola-shops",
    name: "Lola's Gift Shop",
    category: "Flowers & Gifts",
    description: "Curated gift boxes and bouquets with same-day delivery.",
    avatar:
      "https://images.unsplash.com/photo-1519681393784-d120267933ba?auto=format&fit=crop&w=800&q=80",
    tags: ["Same-day delivery", "Card & transfer", "Pickup"],
  },
  {
    id: "spice-kitchen",
    name: "Spice Kitchen",
    category: "Meals & Catering",
    description: "Hearty bowls, platters and office catering with tracked delivery.",
    avatar:
      "https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&w=800&q=80",
    tags: ["Preorder", "Group orders"],
  },
  {
    id: "everyday-market",
    name: "Everyday Market",
    category: "Groceries",
    description:
      "Fresh produce and pantry essentials from your saved vendor list.",
    avatar:
      "https://images.unsplash.com/photo-1467003909585-2f8a72700288?auto=format&fit=crop&w=800&q=80",
    tags: ["Bulk discounts", "Scheduled delivery"],
  },
  {
    id: "tech-hub",
    name: "Tech Hub",
    category: "Devices & Accessories",
    description: "Verified gadgets with pay-on-delivery support in select areas.",
    avatar:
      "https://images.unsplash.com/photo-1498049794561-7780e7231661?auto=format&fit=crop&w=800&q=80",
    tags: ["Warranty", "Same-day pickup"],
  },
];

let catalogStore: CatalogItem[] = [
  {
    id: "cat-flowers",
    userId: DEFAULT_VENDOR_ID,
    name: "Valentine flowers",
    description: "Pretty roses for your lover",
    price: 12000,
    image:
      "https://images.unsplash.com/photo-1528825871115-3581a5387919?auto=format&fit=crop&w=400&q=80",
    inStock: true,
    category: "Flowers & Gifts",
  },
  {
    id: "cat-bouquet",
    userId: DEFAULT_VENDOR_ID,
    name: "Valentines bouquet",
    description: "Finest of roses",
    price: 22000,
    image:
      "https://images.unsplash.com/photo-1519744792095-2f2205e87b6f?auto=format&fit=crop&w=400&q=80",
    inStock: true,
    category: "Flowers & Gifts",
  },
  {
    id: "coffee-latte",
    userId: "coffee-cart",
    name: "Iced Vanilla Latte",
    description: "House syrup, double shot and your choice of milk.",
    price: 3500,
    image:
      "https://images.unsplash.com/photo-1509042239860-f550ce710b93?auto=format&fit=crop&w=800&q=80",
    inStock: true,
    category: "Café & Snacks",
  },
  {
    id: "coffee-box",
    userId: "coffee-cart",
    name: "Team Pastry Box",
    description: "12 assorted pastries for the office.",
    price: 14500,
    image:
      "https://images.unsplash.com/photo-1509440159596-0249088772ff?auto=format&fit=crop&w=800&q=80",
    inStock: true,
    category: "Café & Snacks",
  },
  {
    id: "tech-headphones",
    userId: "tech-market",
    name: "Wireless Headphones",
    description: "ANC, 30hr battery and USB-C fast charge.",
    price: 62000,
    image:
      "https://images.unsplash.com/photo-1511367461989-f85a21fda167?auto=format&fit=crop&w=800&q=80",
    inStock: true,
    category: "Devices & Accessories",
  },
  {
    id: "lola-rose-box",
    userId: "lola-shops",
    name: "Luxury Rose Box",
    description: "24 long-stem roses in a signature Lola's presentation box.",
    price: 45000,
    image:
      "https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=800&q=80",
    inStock: true,
    category: "Bouquets",
  },
  {
    id: "lola-gift-hamper",
    userId: "lola-shops",
    name: "Curated Gift Hamper",
    description: "Candles, chocolates, and keepsakes packed with a handwritten card.",
    price: 32000,
    image:
      "https://images.unsplash.com/photo-1524758631624-e2822e304c36?auto=format&fit=crop&w=800&q=80",
    inStock: true,
    category: "Gifts",
  },
  {
    id: "spice-signature-bowl",
    userId: "spice-kitchen",
    name: "Spice Kitchen Signature Bowl",
    description: "Jollof rice, roasted plantain, and peppered beef in one bowl.",
    price: 18000,
    image:
      "https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&w=800&q=80",
    inStock: true,
    category: "Meals & Catering",
  },
  {
    id: "spice-family-platter",
    userId: "spice-kitchen",
    name: "Family Feast Platter",
    description: "Shared platter with rice, stews, fried yams, and seasonal veggies.",
    price: 42000,
    image:
      "https://images.unsplash.com/photo-1505253758473-1906d2bc1131?auto=format&fit=crop&w=800&q=80",
    inStock: true,
    category: "Meals & Catering",
  },
  {
    id: "everyday-fruit-basket",
    userId: "everyday-market",
    name: "Fresh Fruit Basket",
    description: "Seasonal fruits grouped for the week ahead.",
    price: 12000,
    image:
      "https://images.unsplash.com/photo-1481391014374-8c7b7e9f6e96?auto=format&fit=crop&w=800&q=80",
    inStock: true,
    category: "Groceries",
  },
  {
    id: "everyday-pantry-box",
    userId: "everyday-market",
    name: "Pantry Essentials Box",
    description: "Rice, beans, spices, and pantry staples for small homes.",
    price: 19000,
    image:
      "https://images.unsplash.com/photo-1506806732259-39c2d0268443?auto=format&fit=crop&w=800&q=80",
    inStock: true,
    category: "Groceries",
  },
  {
    id: "tech-hub-earbuds",
    userId: "tech-hub",
    name: "Wireless Earbuds Mini",
    description: "Water-resistant buds with active noise reduction and charging case.",
    price: 48000,
    image:
      "https://images.unsplash.com/photo-1525182008055-f88b95ff7980?auto=format&fit=crop&w=800&q=80",
    inStock: true,
    category: "Devices & Accessories",
  },
  {
    id: "tech-hub-powerbank",
    userId: "tech-hub",
    name: "High-Capacity Power Bank",
    description: "20,000mAh USB-C power bank with fast charging support.",
    price: 26000,
    image:
      "https://images.unsplash.com/photo-1452238815850-9c2cd2b6c812?auto=format&fit=crop&w=800&q=80",
    inStock: true,
    category: "Devices & Accessories",
  },
];

function normalizePath(path: string) {
  if (!path.startsWith("http")) return path;
  try {
    const url = new URL(path);
    return url.pathname + url.search;
  } catch {
    return path;
  }
}

function parseBody(init?: RequestInit) {
  try {
    if (init?.body && typeof init.body === "string") {
      return JSON.parse(init.body);
    }
  } catch {
    /* ignore */
  }
  return {};
}

export async function handle(path: string, init?: RequestInit) {
  const normalized = normalizePath(path);
  const method = (init?.method || "GET").toUpperCase();
  const url = new URL(normalized, "http://mock.local");
  const pathname = url.pathname.replace(/^\/api/, "");
  const scope = url.searchParams.get("scope") || "all";
  const idsParam = url.searchParams.get("ids") || "";
  const requestedIds = idsParam
    ? idsParam.split(",").map((id) => id.trim()).filter(Boolean)
    : [];
  const headers =
    (init?.headers as Record<string, string> | undefined) || {};
  const currentUserId =
    headers["x-user-id"] ||
    headers["X-User-Id"] ||
    headers["x-user-id".toLowerCase()];

  if (pathname.startsWith("/catalog/vendors") && method === "GET") {
    let vendors = vendorFixtures.map((fixture) => {
      const catalogCount = catalogStore.filter(
        (item) => item.userId === fixture.id,
      ).length;
      const status = catalogCount > 0 ? "Open" : "Preorder";
      return {
        id: fixture.id,
        name: fixture.name,
        category: fixture.category,
        description: fixture.description,
        status,
        tags: fixture.tags || [],
        rating: 4.8,
        image: fixture.avatar,
        catalogCount,
      };
    });

    if (currentUserId) {
      vendors = vendors.filter((v) => v.id !== currentUserId);
    }

    if (requestedIds.length > 0) {
      vendors = vendors.filter((v) => requestedIds.includes(v.id));
    }

    return { vendors };
  }

  if (pathname === "/catalog" && method === "GET") {
    const ownerId = url.searchParams.get("userId") || DEFAULT_VENDOR_ID;
    const items = catalogStore
      .filter((item) => item.userId === ownerId)
      .map((item) => ({
        ...item,
        image: item.image || null,
        inStock: item.inStock !== false,
      }));
    return { items };
  }

  if (pathname === "/catalog" && method === "POST") {
    const body = parseBody(init);
    const newItem: CatalogItem = {
      id: `cat-${Date.now()}`,
      userId: DEFAULT_VENDOR_ID,
      name: body.name || "Untitled",
      description: body.description || "",
      price: Number(body.price) || 0,
      image: body.image || null,
      inStock: body.inStock !== false,
      category: body.category || null,
    };
    catalogStore = [newItem, ...catalogStore];
    return { item: newItem };
  }

  if (pathname === "/catalog/image" && method === "POST") {
    return {
      image:
        "https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&w=400&q=80",
    };
  }

  if (/^\/catalog\/[^/]+$/.test(pathname)) {
    const id = pathname.split("/").pop() as string;
    if (method === "PUT") {
      const body = parseBody(init);
      catalogStore = catalogStore.map((item) =>
        item.id === id
          ? {
              ...item,
              ...body,
              price:
                body.price !== undefined ? Number(body.price) : item.price,
              image:
                body.image !== undefined
                  ? body.image || null
                  : item.image || null,
              inStock:
                body.inStock !== undefined ? !!body.inStock : item.inStock,
            }
          : item,
      );
      const updated = catalogStore.find((item) => item.id === id);
      return updated ? { item: updated } : { error: "Not found" };
    }
    if (method === "DELETE") {
      catalogStore = catalogStore.filter((item) => item.id !== id);
      return { success: true };
    }
  }

  return null;
}
